import React from 'react'
import { useTabs } from 'hooks'
import { TabsProvider } from 'hooks/useTabs/provider'
import {
  SecurityItemsAndSubItensProvider,
} from './context'
import { Tab } from 'components/Tab'
import Search from './components/Search'
import AddItemSecurity from './components/AddItemSecurity'

const SecurityItemsAndSubItemsComponent: React.FC = () => {
  const { tabs, selectedTab, handleChangeTab } = useTabs(['Pesquisar', 'Adicionar Novo'])

  return (
    <>
      <Tab
        tabs={tabs}
        value={selectedTab.position}
        handleChange={handleChangeTab}
      />
      {selectedTab.position === 0 && <Search />}
      {selectedTab.position === 1 && <AddItemSecurity />}
    </>
  )
}

const SecurityItemsAndSubItems: React.FC = () => {
  return (
    <TabsProvider>
      <SecurityItemsAndSubItensProvider>
        <SecurityItemsAndSubItemsComponent />
      </SecurityItemsAndSubItensProvider>
    </TabsProvider>
  )
}

export default SecurityItemsAndSubItems
